import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { usePageLoaderContext } from '../../../contexts/PageLoaderContext';
import { useNotification } from '../../../contexts/NotificationContext';
import { useConfirmService } from '../../../services/confirmService';
import GroupsTab from './GroupsTab';
import Tabstyles from '../../../styles/TabContainer.module.css';
import groupManagementStyles from '../../../styles/GroupManagement.module.css';

const GroupManagement: React.FC = () => {
  const { user } = useAuth();
  const { showLoader, hideLoader } = usePageLoaderContext();
  const notificationService = useNotification();
  const confirmService = useConfirmService();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (location.pathname === '/admin/group-management') {
      navigate('/admin/group-management/groups', { replace: true });
    }
  }, [location.pathname, navigate]);

  const getUserName = () => {
    if (!user) return 'User';
    return `${user.first_name} ${user.last_name}`.trim() || user.email;
  };

  if (loading) {
    return null;
  }

  return (
    <div className={groupManagementStyles.groupManagement}>
      {/* Tab Content */}
      <div className={Tabstyles.tabContentContainer}>
          <div className={`${Tabstyles.tabContent} ${Tabstyles.active}`}>
            <GroupsTab />
          </div>
      </div>
    </div>
  );
};

export default GroupManagement;
